// Display stat: eyebrow label over a display numeral (fs-num-xl).
// Numbers earn their size (DESIGN-DIRECTION Bet 3) — money/counts only,
// always mono+tabular via the fs-num tokens.
import type { ReactNode } from 'react';

export function Figure({
  label,
  value,
  sub,
  accent = false,
  size = 30,
}: {
  label: string;
  value: ReactNode;
  sub?: ReactNode;
  accent?: boolean;
  size?: number;
}) {
  return (
    <div>
      <div className="fs-eyebrow" style={{ marginBottom: 8 }}>{label}</div>
      <div className="fs-num-xl" style={{ fontSize: size, color: accent ? 'var(--accent-ink)' : 'var(--ink)' }}>
        {value}
      </div>
      {sub && <div className="fs-meta" style={{ marginTop: 5 }}>{sub}</div>}
    </div>
  );
}
